const getTimeLogTypes = (state: IAppState) => {
  return state.groups.timeLogTypes;
};

const getTimeLogTasks = (state: IAppState) => {
  return state.groups.timeLogTasks;
};

const getInterventions = (state: IAppState) => {
  return state.groups.interventions;
};

const getAvatar = (state: IAppState): string | null => {
  return state.groups.groupAvatar?.url || null;
};

const getQuestionnaires = (state: IAppState): ISurvey[] => {
  return state.groups.questionnaires.data;
};

const getAllCarePrograms = (state: IAppState): ICareProgram[] => {
  const allPrograms = state.groups.carePrograms.reduce((acc: ICareProgram[], groupPrograms) => {
    if (!groupPrograms.programs) return acc;
    return acc.concat(groupPrograms.programs);
  }, []);
  const map = new Map(allPrograms.map((program) => [program.cpid, program]));
  return [...map.values()];
};

const getCarePrograms = (state: IAppState, gid: string): ICareProgram[] => {
  return state.groups.carePrograms.find((program) => program.gid === gid)?.programs || [];
};

const getObservationCollections = (state: IAppState) => {
  return state.groups.observationCollections;
};

const getDeviceOrderings = (state: IAppState) => {
  return state.groups.deviceOrderingsAvailable;
};

export {
  getTimeLogTypes,
  getTimeLogTasks,
  getInterventions,
  getAvatar,
  getQuestionnaires,
  getAllCarePrograms,
  getCarePrograms,
  getObservationCollections,
  getDeviceOrderings
};
